export const getKeyFromEnumValue = <EnumType>(
	enumParsed: { [key: string]: EnumType },
	enumValue: EnumType
) =>
	Object.keys(enumParsed).find(
		(enumParsedKey) => enumParsed[enumParsedKey] === enumValue
	) ?? ''
